export default __webpack_public_path__ + "static/media/shark-label-1.8aa30d78.gif";